<div class="loader text-center" *ngIf="isLoading">
	<img src="../../../assets/images/31.svg">
</div>
<div class="modal-header">
	<div>
		<h1>PREVIEW</h1>
		<p>View the current progress on your landing page. Note that the buttons and links are not intended to be functional in this preview. Close this preview by clicking on the X to return to the previous page, where you can make changes if needed, or add optional sections.</p>
	</div>
	<button type="button" style="float: left;" class="btn-close btn-close-white" data-bs-dismiss="modal"
		aria-label="Close" (click)="onClosePreviewModal()"></button>
</div>
<div class="footer-wrapper">
	<div class="footer-blocker"></div>
	<app-header></app-header>
</div>

<!-- Will landing page html -->
<ng-container *ngIf="landingPageType=='will'">
	<div class="will_page_main_container">
		<section class="first-section desktop-screen" *ngIf="currentTier == 4|| currentTier == 3 || currentTier == 2"
			[ngStyle]="{ 'background-image': 'url(' + basicSectionData?.['orgBannerImage'] + ')' }">
			<div class="">
				<div class="row d-flex justify-content-end">
					<div class="infoContainer">
						<div class="universityDesc">
							<div class="logo_for_all_landing_page">
								<img [src]="basicSectionData?.['orgLogo']" class="img-fluid" height="80">
								<h2 class="fw-bold-first" style="color:white">{{basicSectionData?.['orgName']}}</h2>
							</div>
							<br>
							<div #desc class="first-section-para" [ngClass]="{ 'scroll': showFullDescription }" [class.collapsed]="!showFullDescription" [class.expanded]="showFullDescription"
							[innerHTML]="basicSectionData?.['orgParternshipDescription']">
						</div>
						
						<button *ngIf="showReadMore" (click)="toggleDescription()" class="btn btn-link p-0 read-more-btn">
							{{ showFullDescription ? 'Read Less' : 'Read More' }}
						</button>
						<br ><br>
							<button class="btn btn-primary action-btn width-act">Create Your Free Catholic
								Will Today</button>
							<br>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- <section class="first-section mobile-screen" *ngIf="currentTier == 4 ||currentTier == 3"
			[ngStyle]="{ 'background-image': 'url(' + basicSectionData?.['orgBannerImage'] + ')' }">
			<div class="container">
				<div class="infoContainer">
					<div class="universityDesc p-4 ">
						<div class="logo_for_all_landing_page ">
							<img [src]="basicSectionData?.['orgLogo']" class="img-fluid">
						</div>
						<br>
						<h2 class="fw-bold">{{basicSectionData?.['orgName']}}</h2>
						<p>
							{{basicSectionData?.['orgParternshipDescription']}}
						</p>
						<button class="btn btn-primary action-btn">Create Your Free Catholic Will
							Today</button>
					</div>
				</div>
			</div>
		</section> -->
		<section class="first-section mobile-screen" *ngIf="currentTier == 4 ||currentTier == 3 || currentTier == 2">
            <div class="mobile-img-cntr" [ngStyle]="{ 'background-image': 'url(' + basicSectionData?.['orgBannerImage'] + ')' }">
			</div>
			<div class="container">
				<div class="infoContainer pb-5">
					<div class="universityDesc p-4">
						<div class="logo_for_all_landing_page_mobile ">
							<img [src]="basicSectionData?.['orgLogo']" style="height: 100%; border-radius: 10px;">
						</div>
						<br>
						<h2 class="fw-bold">{{basicSectionData?.['orgName']}}</h2>
						<div #descMob class="first-section-para" [ngClass]="{ 'scroll': showFullDescription }" [class.collapsed]="!showFullDescription" [class.expanded]="showFullDescription" [style.max-height.px]="showFullDescription ? 360 : null" [style.overflow-y]="showFullDescription ? 'auto' : null" [style.webkitOverflowScrolling]="showFullDescription ? 'touch' : null" [innerHTML]="basicSectionData?.['orgParternshipDescription']">
						</div>
						<button  *ngIf="showReadMoreMob" (click)="toggleDescription()" style="color: black" class="btn btn-link p-0 read-more-btn">
							{{ showFullDescription ? 'Read Less' : 'Read More' }}
						</button><br><br><br>

						<button class="btn btn-primary action-btn width-act">
							{{ isSecondaryLandingPage ? 'Get Started Now' : 'Create Your Free Catholic Will Today' }}
						</button>
					</div>
				</div>
			</div>
		</section>
		<!-- Tier-3 Banner section -->
		<!-- <section class="first-section--tier3 desktop-screen" *ngIf="currentTier == 3">
			<div class="container">
				<div class="will3-logo">
					<img [src]="basicSectionData?.['orgLogo']" class="img-fluid" height="80" width="293">
				</div>
				<div class="will3-wrap row">
					<div class="will3-wrap-left col-12 col-lg-5 col-xxl-6">
						<div>
							<img [src]="basicSectionData?.['orgBannerImage']" alt="banner" title="banner" height="411"
								width="627" class="banner-image">
						</div>
					</div>
					<div class="col-12 col-lg-7 col-xxl-6 ps-xxl-0">
						<div class="will3-wrap-right">
							<br>
							<h2 class="fw-bold-first">{{basicSectionData?.['orgName']}}</h2>
							<p class="first-section-para">
								{{basicSectionData?.['orgParternshipDescription']}}
							</p>
							<button class="btn btn-primary action-btn">Create Your Free Catholic
								Will Today</button>
							<br>
						</div>
					</div>
				</div>
			</div>
		</section> -->
		<!-- Tier-2 Banner section -->
		<!-- <section class="first-section--tier2 desktop-screen" *ngIf="currentTier == 2">
			<div class="container">
				<div class="will3-wrap row for-desktop">
					<div class="will3-wrap-left col-12 col-lg-5">
						<div>
							<img [src]="basicSectionData?.['orgBannerImage']" alt="banner" title="banner" class="banner-image">
						</div>
					</div>
					<div class="col-12 col-lg-7">
						<div class="will3-wrap-right">
							<div class="logo_for_all_landing_page ">
								<img [src]="basicSectionData?.['orgLogo']" class="img-fluid" height="80">
							</div>
							<br>
							<h2 class="fw-bold-first" [title]="basicSectionData?.['orgName']">{{basicSectionData?.['orgName']}}</h2>
							<p class="first-section-para"  [innerHTML]="basicSectionData?.['orgParternshipDescription']">
							</p>
							<button class="btn btn-primary action-btn">Create Your Free Catholic
								Will Today</button>
							<br>
						</div>
					</div>
				</div>
				<div class="will3-wrap row for-mobile">
					<div class="col-12">
						<div class="will3-wrap-right">
							<div class="logo_for_all_landing_page mb-3">
								<img [src]="basicSectionData?.['orgLogo']" class="img-fluid" height="80">
							</div>
							<div>
								<img [src]="basicSectionData?.['orgBannerImage']" alt="banner" title="banner" class="banner-image">
							</div>
							<br>
							<h2 class="fw-bold-first" [title]="basicSectionData?.['orgName']">{{basicSectionData?.['orgName']}}</h2>
							<p class="first-section-para" [innerHTML]="basicSectionData?.['orgParternshipDescription']"></p>
							<button class="btn btn-primary action-btn">Create Your Free Catholic
								Will Today</button>
							<br>
						</div>
					</div>
				</div>
			</div>
		</section> -->
		<section class="second-section" *ngIf="(currentTier == 3 || currentTier == 4 || currentTier == 2) && isactiveAboutUs">
			<div class="container" *ngIf="aboutUsSectionData">
				<div class="row d-flex align-items-center second-section-container">
					<div [ngClass]="{
							'col-lg-4': aboutUsSectionData?.['org_mission'],
							'col-lg-12': !aboutUsSectionData?.['org_mission']
						}">
						<div class="custom-university-container">
							<!-- <p class="text-uppercase scndSectionSubHeader"><b>About US</b></p> -->
							<h2 class="fw-bold">About Us</h2>
							<p class="fs" [innerHTML]="aboutUsSectionData?.['our_background']">
							</p>
						</div>
					</div>
					<div class="col-lg-8" *ngIf="aboutUsSectionData?.['org_mission'] && aboutUsSectionData?.['org_vision']">
						<div class="custom-info-box d-flex  text-lg-start align-items-center">
							<img src="./../../../assets/images/arrow-target.png" alt="Mission Icon" class="me-3 mvIcons">
							<div>
								<h5 class="">Mission</h5>
								<p class="fs" [innerHTML]="aboutUsSectionData?.['org_mission']"></p>
							</div>
						</div>
						<div class="custom-info-box d-flex  text-lg-start align-items-center">
							<img src="./../../../assets/images/eye-icon.png" alt="Vision Icon" class="me-3 mvIcons">
							<div>
								<h5 class="">Vision</h5>
								<p class="fs" [innerHTML]="aboutUsSectionData?.['org_vision']"></p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<!-- Tier-2 About US section-->
		<!-- <section class="second-section" *ngIf="currentTier == 2">
			<div class="container">
				<div class="row d-flex align-items-center second-section-container">
					<div class="col-12">
						<div class="custom-university-container">
							<p class="text-uppercase scndSectionSubHeader"><b>About US</b></p>
							<h2 class="fw-bold">Our Background</h2>
							<p class="text-secondary">
								{{aboutUsSectionData?.['our_background']}}

							</p>
						</div>
					</div>
				</div>
			</div>
		</section> -->

		<!-- Tier 4 Supoort our mission -->
		<section class="third-section" *ngIf="(currentTier == 4 || currentTier == 3 || currentTier == 2) && isactiveSupportMission">
			<div class="container">
				<div class="row align-items-center third-section-inner-container ">
					<!-- Left Side - Image -->
					<div class="col-md-5 text-center">
						<img [src]="supportMissionSectionData?.['image_url']" alt="Mission"
							class="img-fluid custom-mission-image">
					</div>
					<!-- Right Side - Text Content -->
					<div class="col-md-7 third-container-desc text-white">
						<h3 class="fw-bold-white" [innerHTML]="getSupportMissionTitle('Support Our Mission with a Gift in Your Will – Create Your Free Will Through Catholic Legacy')">
						</h3>
						<p class="mt-3 third-section-para" [innerHTML]="getSupportMissionDescription(defaultSupportMissionDescription)">
						</p>
						<button class="btn action-btn-white mt-3">
							{{ isSecondaryLandingPage ? 'Get Started Now' : 'Begin Your Estate Planning Journey' }}
						</button>
					</div>
				</div>
			</div>
		</section>
		<!-- Tier 4 Our Work section -->
		<div class="parallex" *ngIf="currentTier == 4 && isactiveInitiative">
			<section class="fourth-section">
				<div class="container">
					<div class="forth-section-inner-container">
						<!-- Title Section -->
						<!-- <p class="text-uppercase fourth-section-header">Our Work</p> -->
						<h2 class="fw-bold py-2">
							Work that Makes a Lasting Impact
						</h2>

						<!-- Grid Section -->
						<div class="row mt-4 text-center justify-content-center">
							<!-- First Row -->
							<ng-container *ngIf="intiativeSectionData && intiativeSectionData.length">
								<div class="col-md-4" *ngFor="let our_work of intiativeSectionData">
									<div class="card border-0">
										<img [src]="our_work?.['image_url']" class="card-img-top rounded-5"
											alt="our work image">
										<div class="card-body">
											<h5 class="header">{{our_work?.['title']}}</h5>
											<p class="text-muted">
												{{our_work?.['description']}}
											</p>
										</div>
									</div>
								</div>
							</ng-container>
						</div>
					</div>
				</div>
			</section>
		</div>
		<!-- Tier 3 Our Work section -->
		<div class="parallex" *ngIf="currentTier == 3 && isactiveInitiative">
			<section class="fourth-section">
				<div class="container">
					<div class="forth-section-inner-container">
						<!-- Title Section -->
						<!-- <p class="text-uppercase fourth-section-header">our Work</p> -->
						<h2 class="fw-bold py-2">
							Work that Makes a Lasting Impact
						</h2>

						<!-- Grid Section -->
						<div class="row mt-4 text-center justify-content-center">
							<!-- First Row -->
							<ng-container *ngIf="intiativeSectionData && intiativeSectionData.length">
								<div class="col-md-4" *ngFor="let our_work of intiativeSectionData">
									<div class="card border-0">
										<img [src]="our_work?.['image_url']" class="card-img-top rounded-5"
											alt="Mother Teresa Project">
										<div class="card-body">
											<h5 class="header">{{our_work?.['title']}}</h5>
											<p class="text-muted">
												{{our_work?.['description']}}
											</p>
										</div>
									</div>
								</div>
							</ng-container>
						</div>
					</div>
				</div>
			</section>
		</div>

		<!-- Tier 2 Our Work section -->
		<div class="parallex" *ngIf="currentTier == 2 && isactiveInitiative">
			<section class="fourth-section">
				<div class="container">
					<div class="forth-section-inner-container">
						<!-- Title Section -->
						<!-- <p class="text-uppercase fourth-section-header">Our Work</p> -->
						<h2 class="fw-bold py-2">
							Work that Makes a Lasting Impact
						</h2>

						<!-- Grid Section -->
						<div class="row mt-4 text-center justify-content-center">
							<!-- First Row -->
							<ng-container *ngIf="intiativeSectionData && intiativeSectionData.length">
								<div class="col-md-4" *ngFor="let our_work of intiativeSectionData">
									<div class="card border-0">
										<img [src]="our_work?.image_url" class="card-img-top rounded-5"
											alt="Key Initiatives and Programs" />
										<div class="card-body">
											<h5 class="header">{{our_work?.['title']}}</h5>
											<p class="text-muted">
												{{our_work?.['description']}}
											</p>
										</div>
									</div>
								</div>
							</ng-container>

						</div>
					</div>
				</div>
			</section>
		</div>
		<ng-container *ngIf="(currentTier == 3 || currentTier == 4 || currentTier == 2) && isactiveState">
			<section class="fifth-section" *ngIf="statisticSetionData && statisticSetionData.length>0">
				<div class="container">
					<!-- Title Section -->
					<div class="fifth-section-inner-container">
						<div class="text-start heading ">
							<!-- <p class="text-uppercase fifth-section-header">Statistics</p> -->
							<h2 class="fw-bold py-2">{{basicSectionData?.orgName}} at a Glance</h2>
						</div>

						<!-- Cards Section -->
						<div class="row mt-4 fifth-container">
							<div class="col-md-6 col-lg-4 mb-4" *ngFor="let stats of statisticSetionData">
								<div class="card h-100 p-4 border-0 shadow-sm rounded-4">
									<div><img src="../../../assets/images/goal.svg"></div>
									<div class="text-start" style="overflow: hidden;">
										<h5 class="card-title statistics-header mb-3">{{stats?.['statistics_title']}}</h5>
										<p class="card-text">{{stats?.['statistics_description']}}</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</ng-container>

		<section class="sixth-section">
			<!-- <div class="container">
				<div class="sixth-section-container">
					<h2 class="fw-bold">Creating a Will with Catholic Legacy in Simple Steps:</h2>
					<div class="steps">
						<img src="./../../../assets/images/wcircular-tile1.png" alt="Signup" class="step-img"
							height="200" width="200">
						<img src="./../../../assets/images/downArrow4.svg" alt="Arrow" class="arrow-img">
						<img src="./../../../assets/images/wcircular-tile2.png" alt="Answer Questions" class="step-img"
							height="200" width="200">
						<img src="./../../../assets/images/downArrow4.svg" alt="Arrow" class="arrow-img">
						<img src="./../../../assets/images/wcircular-tile3.png" alt="Leave a Gift" class="step-img"
							height="200" width="200">
						<img src="./../../../assets/images/downArrow4.svg" alt="Arrow" class="arrow-img">
						<img src="./../../../assets/images/wcircular-tile4.png" alt="Submit Will" class="step-img"
							height="200" width="200">
						<img src="./../../../assets/images/downArrow4.svg" alt="Arrow" class="arrow-img">
						<img src="./../../../assets/images/wcircular-tile5.png" alt="Download PDF" class="step-img"
							height="200" width="200">
					</div>
				</div>
			</div> -->
			<!-- <app-creating-will></app-creating-will> -->
			<div class="will-legacy-section">
				<div class="container container-mobile">
					<h2>Creating a Will is as easy as 1, 2, 3!</h2>
			
				</div>
				<div class="image-row">
					<img src="../../../../assets/images/signUp1.png" alt="Step 1" class="step-image">
					<img src="../../../../assets/images/mobile-arrow1.svg" alt="Down Arrow" class="arrow-image smallScreenArrow">
					<img src="../../../../assets/images/upArrow2.svg" alt="Up Arrow" class="arrow-image largeScreenArrow">
					<img src="../../../../assets/images/answerSome3.png" alt="Step 2" class="step-image">
					<img src="../../../../assets/images/downArrow4.svg" alt="Down Arrow" class="arrow-image largeScreenArrow">
					<img src="../../../../assets/images/mobile-arrow2.svg" alt="Down Arrow" class="arrow-image smallScreenArrow">
					<img src="../../../../assets/images/download5.png" alt="Step 3" class="step-image">
				</div>
				<div class="btn-container">
					<button class="btn btn-primary btn-block action-btn">Start Your Free Catholic
						Will Today</button>
				</div>
			</div>
		</section>

		<section class="seventh-section">
			<div class="container">
				<div class="seventh-section-container">
					<h2 class="section-title fw-bold">How Catholic Legacy Can Help</h2>
					<div class="row justify-content-center">
						<ng-container *ngFor="let chunk of chunkedFeatures">
							<div class="col-md-6 col-lg-3 mb-4" *ngFor="let feature of chunk">
								<div class="feature-box">
									<img [src]="feature.img" [alt]="feature.title">
									<h5 class="mt-3 header">{{ feature.title }}</h5>
									<p>{{ feature?.description }}</p>
								</div>
							</div>
						</ng-container>
					</div>
				</div>

			</div>
		</section>

		<section class="eight-section">
			<div class="container">
				<div class="eight-section-innerContainer">
					<h2 class="fw-bold heading">Why You Need a Will</h2>
					<div class="row mt-4 justify-content-center">
						<div class="col-md-6 col-lg-4 mb-4" *ngFor="let item of willReasons">
							<div class="card custom-card">
								<img [src]="item.icon" class="icon-img mb-3" alt="Icon">
								<h5 class="card-title">{{ item.title }}</h5>
								<p class="card-text">{{ item.description }}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<!-- ninth-section & 10th -->
		<div class="section-one">
			<ng-container *ngTemplateOutlet="catholicLegacyTemplate"></ng-container>
		</div>
	</div>
</ng-container>


<!-- Estate landing page html -->
<ng-container *ngIf="landingPageType=='estate'">

	<div class="estate_landing_main_container">
		<section class="first-section desktop-screen" *ngIf="currentTier == 4 ||currentTier == 3 || currentTier == 2"
			[ngStyle]="{ 'background-image': 'url(' + basicSectionData?.['orgBannerImage'] + ')' }">
			<div class="">
				<div class="row d-flex justify-content-end">
					<div class="infoContainer">
						<div class="universityDesc">
							<div class="logo_for_all_landing_page">
								<img [src]="basicSectionData?.['orgLogo']" class="img-fluid" height="80">
								<h2 class="fw-bold-first" style="color:white">{{basicSectionData?.['orgName']}}</h2>
							</div>
							<br>
							<div #desc class="first-section-para" style="color:white;" [ngClass]="{ 'scroll': showFullDescription }" [class.collapsed]="!showFullDescription" [class.expanded]="showFullDescription" [innerHTML]="basicSectionData?.['orgParternshipDescription']">
							</div>
							<button  *ngIf="showReadMore" (click)="toggleDescription()" class="btn btn-link p-0 read-more-btn">
							{{ showFullDescription ? 'Read Less' : 'Read More' }}
						</button><br><br>
							<button class="btn btn-primary action-btn width-act">Create Your Free
								Catholic
								Will Today</button>
							<br>
						</div>
					</div>
				</div>
			</div>
		</section>
		<section class="first-section mobile-screen" *ngIf="currentTier == 4 || currentTier == 3 || currentTier == 2">
			<!-- <div class="img-bg"></div> -->
			 <div class="mobile-img-cntr" [ngStyle]="{ 'background-image': 'url(' + basicSectionData?.['orgBannerImage'] + ')' }">
			</div>
			<div class="container">
				<div class="infoContainer pb-5">
					<div class="universityDesc p-4">
						<div class="logo_for_all_landing_page_mobile ">
							<img [src]="basicSectionData?.['orgLogo']" style="height: 100%; border-radius: 10px;">
						</div>
						<br>
						<h2 class="fw-bold">{{basicSectionData?.['orgName']}}</h2>
						<div #descMob class="first-section-para" [ngClass]="{ 'scroll': showFullDescription, 'expanded': showFullDescription }" [class.collapsed]="!showFullDescription" [style.max-height.px]="showFullDescription ? 360 : null" [style.overflow-y]="showFullDescription ? 'auto' : null" [style.webkitOverflowScrolling]="showFullDescription ? 'touch' : null" [innerHTML]="basicSectionData?.['orgParternshipDescription']">
							</div>
						<button *ngIf="showReadMoreMob" (click)="toggleDescription()" style="color: black" class="btn btn-link p-0 read-more-btn">
							{{ showFullDescription ? 'Read Less' : 'Read More' }}
						</button><br><br><br>
						<button class="btn btn-primary action-btn width-act">
							{{ isSecondaryLandingPage ? 'Get Started Now' : 'Create Your Free Catholic Will Today' }}
						</button>
					</div>
				</div>
			</div>
		</section>
		<!-- Tier-3 Banner section -->
		<!-- <section class="first-section--tier3 desktop-screen" *ngIf="currentTier == 3">
			<div class="container">
				<div class="will3-logo">
					<img [src]="basicSectionData?.['orgLogo']" class="img-fluid" height="80" width="293">
				</div>
				<div class="will3-wrap row">
					<div class="will3-wrap-left col-12 col-lg-5 col-xxl-6">
						<div>
							<img [src]="basicSectionData?.['orgBannerImage']" alt="banner" title="banner" height="411"
								width="627" class="banner-image">
						</div>
					</div>
					<div class="col-12 col-lg-7 col-xxl-6 ps-xxl-0">
						<div class="will3-wrap-right">
							<br>
							<h2 class="fw-bold-first">{{basicSectionData?.['orgName']}}</h2>
							<p class="first-section-para">
								{{basicSectionData?.['orgParternshipDescription']}}
							</p>
							<button class="btn btn-primary action-btn">Create Your Free
								Catholic
								Will Today</button>
							<br>
						</div>
					</div>
				</div>
			</div>
		</section> -->
		<!-- Tier-2 Banner section -->
		<!-- <section class="first-section--tier2 desktop-screen" *ngIf="currentTier == 2">
			<div class="container">
				<div class="will3-wrap row for-desktop">
					<div class="will3-wrap-left col-12 col-lg-5">
						<div>
							<img [src]="basicSectionData?.['orgBannerImage']" alt="banner" title="banner" class="banner-image">
						</div>
					</div>
					<div class="col-12 col-lg-7">
						<div class="will3-wrap-right">
							<div class="logo_for_all_landing_page">
								<img [src]="basicSectionData?.['orgLogo']" class="img-fluid" height="80">
							</div>
							<br>
							<h2 class="fw-bold-first" [title]="basicSectionData?.['orgName']">{{basicSectionData?.['orgName']}}</h2>
							<p class="first-section-para" [innerHTML]="basicSectionData?.['orgParternshipDescription']">
							</p>
							<button class="btn btn-primary action-btn">Create Your Free
								Catholic
								Will Today</button>
							<br>
						</div>
					</div>
				</div>
				<div class="will3-wrap row for-mobile">
					<div class="col-12">
						<div class="will3-wrap-right">
							<div class="logo_for_all_landing_page mb-3">
								<img [src]="basicSectionData?.['orgLogo']" class="img-fluid" height="80">
							</div>
							<div>
								<img [src]="basicSectionData?.['orgBannerImage']" alt="banner" title="banner" class="banner-image">
							</div>
							<br>
							<h2 class="fw-bold-first" [title]="basicSectionData?.['orgName']">{{basicSectionData?.['orgName']}}</h2>
							<p class="first-section-para" [innerHTML]="basicSectionData?.['orgParternshipDescription']">
							</p>
							<button class="btn btn-primary action-btn">Create Your Free
								Catholic
								Will Today</button>
							<br>
						</div>
					</div>
				</div>
			</div>
		</section> -->
		<section class="second-section" *ngIf="(currentTier == 3 || currentTier == 4 || currentTier == 2) && isactiveAboutUs">
			<div class="container">
				<div class="row d-flex align-items-center second-section-container">
					<div [ngClass]="{
							'col-lg-4': aboutUsSectionData?.['org_mission'],
							'col-lg-12': !aboutUsSectionData?.['org_mission']
						}">
						<div class="custom-university-container">
							<!-- <p class="text-uppercase scndSectionSubHeader"><b>About US</b></p> -->
							<h2 class="fw-bold">About Us</h2>
							<p class="fs" [innerHTML]="aboutUsSectionData?.['our_background']">
							</p>
						</div>
					</div>
					<div class="col-lg-8" *ngIf="aboutUsSectionData?.['org_mission'] && aboutUsSectionData?.['org_vision']">
						<div class="custom-info-box d-flex  text-lg-start align-items-center">
							<img src="./../../../assets/images/arrow-target.png" alt="Mission Icon" class="me-3 mvIcons">
							<div>
								<h5 class="">Mission</h5>
								<p class="fs" [innerHtml]="aboutUsSectionData?.['org_mission']"></p>
							</div>
						</div>
						<div class="custom-info-box d-flex  text-lg-start align-items-center">
							<img src="./../../../assets/images/eye-icon.png" alt="Vision Icon" class="me-3 mvIcons">
							<div>
								<h5 class="">Vision</h5>
								<p class="fs" [innerHtml]="aboutUsSectionData?.['org_vision']"></p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<!-- Tier-2 About US section-->
		<!-- <section class="second-section" *ngIf="currentTier == 2">
			<div class="container">
				<div class="row d-flex align-items-center second-section-container">
					<div class="col-12">
						<div class="custom-university-container">
							<p class="text-uppercase scndSectionSubHeader"><b>About US</b></p>
							<h2 class="fw-bold">Our Background</h2>
							<p class="text-secondary">
								{{aboutUsSectionData?.['our_background']}}
							</p>
						</div>
					</div>
				</div>
			</div>
		</section> -->

		<!-- Tier 4 Supoort our mission -->
		<section class="third-section" *ngIf="(currentTier == 4 || currentTier == 3 || currentTier == 2) && isactiveSupportMission">
			<div class="container">
				<div class="row align-items-center third-section-inner-container ">
					<!-- Left Side - Image -->
					<div class="col-md-5 text-center">
						<img [src]="supportMissionSectionData?.['image_url']" alt="Mission"
							class="img-fluid custom-mission-image">
					</div>
					<!-- Right Side - Text Content -->
					<div class="col-md-7 third-container-desc text-white">
						<h3 class="fw-bold-white" [innerHTML]="getSupportMissionTitle('Support Our Mission with a Gift in Your Will – Create Your Free Will Through Catholic Legacy')">
						</h3>
						<p class="mt-3 third-section-para" [innerHTML]="getSupportMissionDescription(defaultSupportMissionDescription)">
						</p>
						<button class="btn action-btn-white mt-3">
							{{ isSecondaryLandingPage ? 'Get Started Now' : 'Begin Your Estate Planning Journey' }}
						</button>
					</div>
				</div>
			</div>
		</section>

		<!-- Tier 4 Our Work section -->
		<div class="parallex" *ngIf="currentTier == 4 && isactiveInitiative">
			<section class="fourth-section">
				<div class="container">
					<div class="forth-section-inner-container">
						<!-- Title Section -->
						<!-- <p class="text-uppercase fourth-section-header">our Work</p> -->
						<h2 class="fw-bold py-2">
							Work that Makes a Lasting Impact
						</h2>

						<!-- Grid Section -->
						<div class="row mt-4 text-center justify-content-center">
							<!-- First Row -->
							<ng-container *ngIf="intiativeSectionData && intiativeSectionData">
								<div class="col-md-4" *ngFor="let our_work of intiativeSectionData">
									<div class="card border-0">
										<img [src]="our_work?.['image_url']" class="card-img-top rounded-5"
											alt="Mother Teresa Project">
										<div class="card-body">
											<h5 class="header">{{our_work?.['title']}}</h5>
											<p class="text-muted">
												{{our_work?.['description']}}
											</p>
										</div>
									</div>
								</div>
							</ng-container>
						</div>
					</div>
				</div>
			</section>
		</div>
		<!-- Tier 3 Our Work section -->
		<div class="parallex" *ngIf="currentTier == 3 && isactiveInitiative">
			<section class="fourth-section">
				<div class="container">
					<div class="forth-section-inner-container">
						<!-- Title Section -->
						<!-- <p class="text-uppercase fourth-section-header">our Work</p> -->
						<h2 class="fw-bold py-2">
							Work that Makes a Lasting Impact
						</h2>

						<!-- Grid Section -->
						<div class="row mt-4 text-center justify-content-center">
							<!-- First Row -->
							<ng-container *ngIf="intiativeSectionData && intiativeSectionData">
								<div class="col-md-4" *ngFor="let our_work of intiativeSectionData">
									<div class="card border-0">
										<img [src]="our_work?.['image_url']" class="card-img-top rounded-5"
											alt="Mother Teresa Project">
										<div class="card-body">
											<h5 class="header">{{our_work?.['title']}}</h5>
											<p class="text-muted">
												{{our_work?.['description']}}
											</p>
										</div>
									</div>
								</div>
							</ng-container>
						</div>
					</div>
				</div>
			</section>
		</div>

		<!-- Tier 2 Our Work section -->
		<div class="parallex" *ngIf="currentTier == 2 && isactiveInitiative">
			<section class="fourth-section">
				<div class="container">
					<div class="forth-section-inner-container">
						<!-- Title Section -->
						<!-- <p class="text-uppercase fourth-section-header">our Work</p> -->
						<h2 class="fw-bold py-2">
							Work that Makes a Lasting Impact
						</h2>

						<!-- Grid Section -->
						<div class="row mt-4 text-center justify-content-center">
							<!-- First Row -->
							<ng-container *ngIf="intiativeSectionData && intiativeSectionData">
								<div class="col-md-4" *ngFor="let our_work of intiativeSectionData">
									<div class="card border-0">
										<img [src]="our_work?.image_url" class="card-img-top rounded-5"
											alt="Key Initiatives and Programs" />
										<div class="card-body">
											<h5 class="header">{{our_work?.['title']}}</h5>
											<p class="text-muted">
												{{our_work?.['description']}}
											</p>
										</div>
									</div>
								</div>
							</ng-container>
						</div>
					</div>
				</div>
			</section>
		</div>
		<ng-container *ngIf="(currentTier == 3 || currentTier == 4 || currentTier ==2 ) && isactiveState">
			<section class="fifth-section" *ngIf="statisticSetionData && statisticSetionData.length>0">
				<div class="container">
					<!-- Title Section -->
					<div class="fifth-section-inner-container">
						<div class="text-start heading ">
							<!-- <p class="text-uppercase fifth-section-header">Statistics</p> -->
							<h2 class="fw-bold py-2">{{basicSectionData['orgName']}} at a Glance</h2>
						</div>

						<!-- Cards Section -->
						<div class="row mt-4 fifth-container">
							<div class="col-md-6 col-lg-4 mb-4" *ngFor="let stats of statisticSetionData">
								<div class="card h-100 p-4 border-0 shadow-sm rounded-4">
									<div><img src="../../../assets/images/goal.svg"></div>
									<div class="text-start" style="overflow: hidden;">
										<h5 class="card-title  statistics-header mb-3">{{stats?.['statistics_title']}}</h5>
										<p class="card-text">{{stats?.['statistics_description']}}</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</ng-container>

		<section class="sixth-section">
			<!-- <div class="container">
				<div class="sixth-section-container">
					<h2 class="fw-bold">Creating a Will with Catholic Legacy in Simple Steps:</h2>
					<div class="steps">
						<img src="./../../../assets/images/wcircular-tile1.png" alt="Signup" class="step-img"
							height="200" width="200">
						<img src="./../../../assets/images/downArrow4.svg" alt="Arrow" class="arrow-img">
						<img src="./../../../assets/images/wcircular-tile2.png" alt="Answer Questions" class="step-img"
							height="200" width="200">
						<img src="./../../../assets/images/downArrow4.svg" alt="Arrow" class="arrow-img">
						<img src="./../../../assets/images/wcircular-tile3.png" alt="Leave a Gift" class="step-img"
							height="200" width="200">
						<img src="./../../../assets/images/downArrow4.svg" alt="Arrow" class="arrow-img">
						<img src="./../../../assets/images/wcircular-tile4.png" alt="Submit Will" class="step-img"
							height="200" width="200">
						<img src="./../../../assets/images/downArrow4.svg" alt="Arrow" class="arrow-img">
						<img src="./../../../assets/images/wcircular-tile5.png" alt="Download PDF" class="step-img"
							height="200" width="200">
					</div>
				</div>
			</div> -->
			<!-- <app-creating-will></app-creating-will> -->
			 <div class="will-legacy-section">
				<div class="container container-mobile">
					<h2>Creating a Will is as easy as 1, 2, 3!</h2>
			
				</div>
				<div class="image-row">
					<img src="../../../../assets/images/signUp1.png" alt="Step 1" class="step-image">
					<img src="../../../../assets/images/mobile-arrow1.svg" alt="Down Arrow" class="arrow-image smallScreenArrow">
					<img src="../../../../assets/images/upArrow2.svg" alt="Up Arrow" class="arrow-image largeScreenArrow">
					<img src="../../../../assets/images/answerSome3.png" alt="Step 2" class="step-image">
					<img src="../../../../assets/images/downArrow4.svg" alt="Down Arrow" class="arrow-image largeScreenArrow">
					<img src="../../../../assets/images/mobile-arrow2.svg" alt="Down Arrow" class="arrow-image smallScreenArrow">
					<img src="../../../../assets/images/download5.png" alt="Step 3" class="step-image">
				</div>
				<div class="btn-container">
					<button class="btn btn-primary btn-block action-btn">Start Your Free Catholic
						Will Today</button>
				</div>
			</div>
		</section>

		<section class="seventh-section">
			<div class="container">
				<div class="seventh-section-container">
					<h2 class="section-title fw-bold">Why Start with Catholic Legacy?</h2>
					<div class="row justify-content-center">
						<ng-container *ngFor="let chunk of chunkedEstateFeatures">
							<div class="col-md-6 col-lg-4 mb-4" *ngFor="let feature of chunk">
								<div class="feature-box">
									<img [src]="feature.img" [alt]="feature.title">
									<h5 class="mt-3 header">{{ feature.title }}</h5>
									<p>{{ feature.description }}</p>
								</div>
							</div>
						</ng-container>
					</div>
					<div class="text-center">
						<p>Don't delay. Start planning your estate and create your free Catholic Will today with
							Catholic
							Legacy.</p>
						<button class="btn btn-primary action-btn">Start Your Free Catholic Will Today</button>
					</div>
				</div>

			</div>
		</section>

		<section class="estate-attorney">
			<div class="container">
				<h2 class="section-title fw-bold">What’s the Difference Between an Estate Attorney and Catholic Legacy?
				</h2>
				<div class="estate-attorney-container">
					<div class="row">
						<div class="col-12 col-lg-6 pe-3">
							<h3 class="estate-attorney-title">Estate Attorney</h3>
							<div class="d-flex flex-column">
								<div class="d-flex align-items-start alist-item">
									<div class="flex-shrink-0 tick-icon">
										<img src="./../../../assets/images/cross-icon.png" alt="cross-icon"
											class="flex-shrink-0" height="14" width="14">
									</div>
									<div class="d-flex flex-column">
										<h5>Difficult to Find</h5>
										<p>Hard to find attorneys who align with your faith.</p>
									</div>
								</div>
								<div class="d-flex align-items-start alist-item">
									<div class="flex-shrink-0 tick-icon">
										<img src="./../../../assets/images/cross-icon.png" alt="cross-icon"
											class="flex-shrink-0" height="14" width="14">
									</div>
									<div class="d-flex flex-column">
										<h5>High Costs</h5>
										<p>Expensive legal fees, even for simple Wills.</p>
									</div>
								</div>
								<div class="d-flex align-items-start alist-item">
									<div class="flex-shrink-0 tick-icon">
										<img src="./../../../assets/images/cross-icon.png" alt="cross-icon"
											class="flex-shrink-0" height="14" width="14">
									</div>
									<div class="d-flex flex-column">
										<h5>Time-Consuming</h5>
										<p>Weeks or months to finalize a Will.</p>
									</div>
								</div>
							</div>
						</div>
						<div class="col-12 mt-5 mt-lg-0 col-lg-6 ps-3">
							<h3 class="estate-attorney-title">Our Online Will Service</h3>
							<div class="d-flex flex-column">
								<div class="d-flex align-items-start alist-item">
									<div class="flex-shrink-0 tick-icon">
										<img src="./../../../assets/images/tick-icon.png" alt="tick-icon"
											class="flex-shrink-0" height="18" width="20">
									</div>
									<div class="d-flex flex-column">
										<h5>Free and Accessible</h5>
										<p>Create a Will in under 30 minutes, free of cost.</p>
									</div>
								</div>
								<div class="d-flex align-items-start alist-item">
									<div class="flex-shrink-0 tick-icon">
										<img src="./../../../assets/images/tick-icon.png" alt="tick-icon"
											class="flex-shrink-0" height="18" width="20">
									</div>
									<div class="d-flex flex-column">
										<h5>Built by Legal Experts</h5>
										<p>Designed by estate attorneys, legally sound.</p>
									</div>
								</div>
								<div class="d-flex align-items-start alist-item">
									<div class="flex-shrink-0 tick-icon">
										<img src="./../../../assets/images/tick-icon.png" alt="tick-icon"
											class="flex-shrink-0" height="18" width="20">
									</div>
									<div class="d-flex flex-column">
										<h5>Flexibility</h5>
										<p>Update your Will anytime, at no extra cost.</p>
									</div>
								</div>
								<div class="d-flex align-items-start alist-item">
									<div class="flex-shrink-0 tick-icon">
										<img src="./../../../assets/images/tick-icon.png" alt="tick-icon"
											class="flex-shrink-0" height="18" width="20">
									</div>
									<div class="d-flex flex-column">
										<h5>Option to Consult an Attorney</h5>
										<p>Start with us, consult an attorney if needed.</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<!-- ninth-section & 10th -->
		<div class="section-one">
			<ng-container *ngTemplateOutlet="catholicLegacyTemplate"></ng-container>
		</div>
	</div>
</ng-container>



<!-- All product compoenent -->
<ng-container *ngIf="landingPageType=='allproducts'">

	<div class="all_products_main_container">
		<section class="first-section desktop-screen" *ngIf="currentTier == 4 ||currentTier == 3 || currentTier == 2"
			[ngStyle]="{ 'background-image': 'url(' + basicSectionData?.['orgBannerImage'] + ')' }">
			<div class="">
				<div class="row d-flex justify-content-end">
					<div class="infoContainer">
						<div class="universityDesc">
							<div class="logo_for_all_landing_page">
								<img [src]="basicSectionData?.['orgLogo']" class="img-fluid" height="80">
								<h2 class="fw-bold-first" style="color:white">{{basicSectionData?.['orgName']}}</h2>
							</div>
							<br>
							<div #desc class="first-section-para" style="color:white;" [ngClass]="{ 'scroll': showFullDescription, 'expanded': showFullDescription }" [class.collapsed]="!showFullDescription" [innerHTML]="basicSectionData?.['orgParternshipDescription']">
							</div>
							<button *ngIf="showReadMore" (click)="toggleDescription()" class="btn btn-link p-0 read-more-btn">
							{{ showFullDescription ? 'Read Less' : 'Read More' }}
						</button><br><br>
							<button class="btn btn-primary action-btn width-act">Create Your Free
								Catholic
								Will Today</button>
							<br>
						</div>
					</div>
				</div>
			</div>
		</section>
		<section class="first-section mobile-screen" *ngIf="currentTier == 4||currentTier == 3 || currentTier == 2">
			<!-- <div class="img-bg"></div> -->
			  <div class="mobile-img-cntr" [ngStyle]="{ 'background-image': 'url(' + basicSectionData?.['orgBannerImage'] + ')' }">
			</div>
			<div class="container">
				<div class="infoContainer pb-5">
					<div class="universityDesc p-4">
						<div class="logo_for_all_landing_page_mobile ">
							<img [src]="basicSectionData?.['orgLogo']" style="height: 100%; border-radius: 10px;">
						</div>
						<br>
						<h2 class="fw-bold">{{basicSectionData?.['orgName']}}</h2>
						<div #descMob class="first-section-para" [ngClass]="{ 'scroll': showFullDescription, 'expanded': showFullDescription }" [class.collapsed]="!showFullDescription" [style.max-height.px]="showFullDescription ? 360 : null" [style.overflow-y]="showFullDescription ? 'auto' : null" [style.webkitOverflowScrolling]="showFullDescription ? 'touch' : null" [innerHTML]="basicSectionData?.['orgParternshipDescription']"></div>
						<button  *ngIf="showReadMoreMob" (click)="toggleDescription()" style="color: black" class="btn btn-link p-0 read-more-btn">
							{{ showFullDescription ? 'Read Less' : 'Read More' }}
						</button><br><br><br>
						<button class="btn btn-primary action-btn width-act">
							{{ isSecondaryLandingPage ? 'Get Started Now' : 'Create Your Free Catholic Will Today' }}
						</button>
					</div>
				</div>
			</div>
		</section>
		<!-- Tier-3 Banner section -->
		<!-- <section class="first-section--tier3 desktop-screen" *ngIf="currentTier == 3">
			<div class="container">
				<div class="will3-logo">
					<img [src]="basicSectionData?.['orgLogo']" class="img-fluid" height="80" width="293">
				</div>
				<div class="will3-wrap row">
					<div class="will3-wrap-left col-12 col-lg-5 col-xxl-6">
						<div>
							<img [src]="basicSectionData?.['orgBannerImage']" alt="banner" title="banner" height="411"
								width="627" class="banner-image">
						</div>
					</div>
					<div class="col-12 col-lg-7 col-xxl-6 ps-xxl-0">
						<div class="will3-wrap-right">
							<br>
							<h2 class="fw-bold-first">{{basicSectionData?.['orgName']}}</h2>
							<p class="first-section-para">
								{{basicSectionData?.['orgParternshipDescription']}}
							</p>
							<button class="btn btn-primary action-btn">Create Your Free
								Catholic
								Will Today</button>
							<br>
						</div>
					</div>
				</div>
			</div>
		</section> -->
		<!-- Tier-2 Banner section -->
		<!-- <section class="first-section--tier2 desktop-screen" *ngIf="currentTier == 2">
			<div class="container">
				<div class="will3-wrap row for-desktop">
					<div class="will3-wrap-left col-12 col-lg-5">
						<div>
							<img [src]="basicSectionData?.['orgBannerImage']" alt="banner" title="banner" class="banner-image">
						</div>
					</div>
					<div class="col-12 col-lg-7">
						<div class="will3-wrap-right">
							<div class="logo_for_all_landing_page">
								<img [src]="basicSectionData?.['orgLogo']" class="img-fluid" height="80">
							</div>
							<br>
							<h2 class="fw-bold-first" [title]="basicSectionData?.['orgName']">{{basicSectionData?.['orgName']}}</h2>
							<p class="first-section-para" [innerHTML]="basicSectionData?.['orgParternshipDescription']">
							</p>
							<button class="btn btn-primary action-btn">Create Your Free
								Catholic
								Will Today</button>
							<br>
						</div>
					</div>
				</div>
				<div class="will3-wrap row for-mobile">
					<div class="col-12">
						<div class="will3-wrap-right">
							<div class="logo_for_all_landing_page mb-3">
								<img [src]="basicSectionData?.['orgLogo']" class="img-fluid" height="80">
							</div>
							<div>
								<img [src]="basicSectionData?.['orgBannerImage']" alt="banner" title="banner" class="banner-image">
							</div>
							<br>
							<h2 class="fw-bold-first" [title]="basicSectionData?.['orgName']">{{basicSectionData?.['orgName']}}</h2>
							<p class="first-section-para" [innerHTML]="basicSectionData?.['orgParternshipDescription']">
							</p>
							<button class="btn btn-primary action-btn">Create Your Free
								Catholic
								Will Today</button>
							<br>
						</div>
					</div>
				</div>
			</div>
		</section> -->
		<section class="second-section" *ngIf="(currentTier == 3 || currentTier == 4 || currentTier == 2) && isactiveAboutUs">
			<div class="container">
				<div class="row d-flex align-items-center second-section-container">
					<div [ngClass]="{
							'col-lg-4': aboutUsSectionData?.['org_mission'],
							'col-lg-12': !aboutUsSectionData?.['org_mission']
						}">
						<div class="custom-university-container">
							<!-- <p class="text-uppercase scndSectionSubHeader"><b>About US</b></p> -->
							<h2 class="fw-bold">About Us</h2>
							<p class="fs"  [innerHTML]="aboutUsSectionData?.['our_background']">
							</p>
						</div>
					</div>
					<div class="col-lg-8" *ngIf="aboutUsSectionData?.['org_mission'] && aboutUsSectionData?.['org_vision']">
						<div class="custom-info-box d-flex text-lg-start align-items-center">
							<img src="./../../../assets/images/arrow-target.png" alt="Mission Icon" class="me-3">
							<div>
								<h5 class="">Mission</h5>
								<p class="fs" [innerHtml]="aboutUsSectionData?.['org_mission']"></p>
							</div>
						</div>
						<div class="custom-info-box d-flex text-lg-start align-items-center">
							<img src="./../../../assets/images/eye-icon.png" alt="Vision Icon" class="me-3 mvIcons">
							<div>
								<h5 class="">Vision</h5>
								<p class="fs" [innerHtml]="aboutUsSectionData?.['org_vision']"></p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<!-- Tier-2 About US section-->
		<!-- <section class="second-section" *ngIf="currentTier == 2">
			<div class="container">
				<div class="row d-flex align-items-center second-section-container">
					<div class="col-12">
						<div class="custom-university-container">
							<p class="text-uppercase scndSectionSubHeader"><b>About US</b></p>
							<h2 class="fw-bold">Our Background</h2>
							<p class="text-secondary">
								{{aboutUsSectionData?.['our_background']}}
							</p>
						</div>
					</div>
				</div>
			</div>
		</section> -->

		<!-- Tier 4 Supoort our mission -->
		<section class="third-section" *ngIf="(currentTier == 4 || currentTier == 3 || currentTier == 2) && isactiveSupportMission">
			<div class="container">
				<div class="row align-items-center third-section-inner-container ">
					<!-- Left Side - Image -->
					<div class="col-md-5 text-center">
						<img [src]="supportMissionSectionData?.['image_url']" alt="Mission"
							class="img-fluid custom-mission-image">
					</div>
					<!-- Right Side - Text Content -->
					<div class="col-md-7 third-container-desc text-white">
						<h3 class="fw-bold-white" [innerHTML]="getSupportMissionTitle('Support Our Mission with a Gift in Your Will – Create Your Free Will Through Catholic Legacy')">
						</h3>
						<p class="mt-3 third-section-para" [innerHTML]="getSupportMissionDescription(defaultSupportMissionDescription)">
						</p>
						<button class="btn action-btn-white mt-3">
							{{ isSecondaryLandingPage ? 'Get Started Now' : 'Begin Your Estate Planning Journey' }}
						</button>
					</div>
				</div>
			</div>
		</section>

		<!-- Tier 4 Our Work section -->
		<div class="parallex" *ngIf="currentTier == 4 && isactiveInitiative">
			<section class="fourth-section">
				<div class="container">
					<div class="forth-section-inner-container">
						<!-- Title Section -->
						<!-- <p class="text-uppercase fourth-section-header">our Work</p> -->
						<h2 class="fw-bold py-2">
							Work that Makes a Lasting Impact
						</h2>

						<!-- Grid Section -->
						<ng-container *ngIf="intiativeSectionData && intiativeSectionData">

							<div class="row mt-4 text-center justify-content-center">
								<!-- First Row -->
								<div class="col-md-4" *ngFor="let our_work of intiativeSectionData">
									<div class="card border-0">
										<img [src]="our_work?.['image_url']" class="card-img-top rounded-5"
											alt="Mother Teresa Project">
										<div class="card-body">
											<h5 class="header">{{our_work?.['title']}}</h5>
											<p class="text-muted">
												{{our_work?.['description']}}
											</p>
										</div>
									</div>
								</div>
							</div>
						</ng-container>

					</div>
				</div>
			</section>
		</div>
		<!-- Tier 3 Our Work section -->
		<div class="parallex" *ngIf="currentTier == 3 && isactiveInitiative">
			<section class="fourth-section">
				<div class="container">
					<div class="forth-section-inner-container">
						<!-- Title Section -->
						<!-- <p class="text-uppercase fourth-section-header">our Work</p> -->
						<h2 class="fw-bold py-2">
							Work that Makes a Lasting Impact
						</h2>
						<ng-container *ngIf="intiativeSectionData && intiativeSectionData">

							<div class="row mt-4 text-center justify-content-center">
								<!-- First Row -->
								<div class="col-md-4" *ngFor="let our_work of intiativeSectionData">
									<div class="card border-0">
										<img [src]="our_work?.['image_url']" class="card-img-top rounded-5"
											alt="Mother Teresa Project">
										<div class="card-body">
											<h5 class="header">{{our_work?.['title']}}</h5>
											<p class="text-muted">
												{{our_work?.['description']}}
											</p>
										</div>
									</div>
								</div>
							</div>
						</ng-container>
						<!-- Grid Section -->
					</div>
				</div>
			</section>
		</div>

		<!-- Tier 2 Our Work section -->
		<div class="parallex" *ngIf="currentTier == 2 && isactiveInitiative">
			<section class="fourth-section">
				<div class="container">
					<div class="forth-section-inner-container">
						<!-- Title Section -->
						<!-- <p class="text-uppercase fourth-section-header">our Work</p> -->
						<h2 class="fw-bold py-2">
							Work that Makes a Lasting Impact
						</h2>
						<ng-container *ngIf="intiativeSectionData && intiativeSectionData">

							<div class="row mt-4 text-center justify-content-center">
								<!-- First Row -->
								<div class="col-md-4" *ngFor="let our_work of intiativeSectionData">
									<div class="card border-0">
										<img [src]="our_work?.image_url" class="card-img-top rounded-5"
											alt="Key Initiatives and Programs" />
										<div class="card-body">
											<h5 class="header">{{our_work?.['title']}}</h5>
											<p class="text-muted">
												{{our_work?.['description']}}
											</p>
										</div>
									</div>
								</div>
							</div>
						</ng-container>
						<!-- Grid Section -->
					</div>
				</div>
			</section>
		</div>

		<ng-container *ngIf="(currentTier == 3 || currentTier == 4 || currentTier == 2) && isactiveState">
			<section class="fifth-section" *ngIf="statisticSetionData && statisticSetionData.length>0">
				<div class="container">
					<!-- Title Section -->
					<div class="fifth-section-inner-container">
						<div class="text-start heading ">
							<!-- <p class="text-uppercase fifth-section-header">Statistics</p> -->
							<h2 class="fw-bold py-2">{{basicSectionData['orgName']}} at a Glance</h2>
						</div>

						<!-- Cards Section -->
						<div class="row mt-4 fifth-container">
							<div class="col-md-6 col-lg-4 mb-4" *ngFor="let stats of statisticSetionData">
								<div class="card h-100 p-4 border-0 shadow-sm rounded-4">
									<div><img src="../../../assets/images/goal.svg"></div>
									<div class="text-start" style="overflow: hidden;">
										<h5 class="card-title statistics-header mb-3">{{stats?.['statistics_title']}}</h5>
										<p class="card-text">{{stats?.['statistics_description']}}</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</ng-container>


		<section class="sixth-section">
			<!-- <div class="container">
				<div class="sixth-section-container">
					<h2 class="fw-bold">Creating a Will with Catholic Legacy in Simple Steps:</h2>
					<div class="steps">
						<img src="./../../../assets/images/wcircular-tile1.png" alt="Signup" class="step-img"
							height="200" width="200">
						<img src="./../../../assets/images/downArrow4.svg" alt="Arrow" class="arrow-img">
						<img src="./../../../assets/images/wcircular-tile2.png" alt="Answer Questions" class="step-img"
							height="200" width="200">
						<img src="./../../../assets/images/downArrow4.svg" alt="Arrow" class="arrow-img">
						<img src="./../../../assets/images/wcircular-tile3.png" alt="Leave a Gift" class="step-img"
							height="200" width="200">
						<img src="./../../../assets/images/downArrow4.svg" alt="Arrow" class="arrow-img">
						<img src="./../../../assets/images/wcircular-tile4.png" alt="Submit Will" class="step-img"
							height="200" width="200">
						<img src="./../../../assets/images/downArrow4.svg" alt="Arrow" class="arrow-img">
						<img src="./../../../assets/images/wcircular-tile5.png" alt="Download PDF" class="step-img"
							height="200" width="200">
					</div>
				</div>
			</div> -->
			<!-- <app-creating-will></app-creating-will> -->
			 <div class="will-legacy-section">
				<div class="container container-mobile">
					<h2>Creating a Will is as easy as 1, 2, 3!</h2>
			
				</div>
				<div class="image-row">
					<img src="../../../../assets/images/signUp1.png" alt="Step 1" class="step-image">
					<img src="../../../../assets/images/mobile-arrow1.svg" alt="Down Arrow" class="arrow-image smallScreenArrow">
					<img src="../../../../assets/images/upArrow2.svg" alt="Up Arrow" class="arrow-image largeScreenArrow">
					<img src="../../../../assets/images/answerSome3.png" alt="Step 2" class="step-image">
					<img src="../../../../assets/images/downArrow4.svg" alt="Down Arrow" class="arrow-image largeScreenArrow">
					<img src="../../../../assets/images/mobile-arrow2.svg" alt="Down Arrow" class="arrow-image smallScreenArrow">
					<img src="../../../../assets/images/download5.png" alt="Step 3" class="step-image">
				</div>
				<div class="btn-container">
					<button class="btn btn-primary btn-block action-btn">Start Your Free Catholic
						Will Today</button>
				</div>
			</div>
		</section>

		<!-- <section class="seventh-section">
		    <div class="container">
		        <div class="seventh-section-container">
		            <h2 class="section-title fw-bold">Why Start with Catholic Legacy?</h2>
		            <div class="row justify-content-center">
		              <ng-container *ngFor="let chunk of chunkedFeatures">
		                <div class="col-md-6 col-lg-4 mb-4" *ngFor="let feature of chunk">
		                  <div class="feature-box">
		                    <img [src]="feature.img" [alt]="feature.title">
		                    <h5 class="mt-3 header">{{ feature.title }}</h5>
		                    <p>{{ feature.description }}</p>
		                  </div>
		                </div>
		              </ng-container>
		            </div>
		            <div class="text-center">
		                <p>Don't delay. Start planning your estate and create your free Catholic Will today with Catholic Legacy.</p>
		                <button class="btn btn-primary action-btn">Start your free Catholic will today</button>
		            </div>
		          </div>

		    </div>
		</section> -->

		<section class="catholic-legcay-meets">
			<div class="container">
				<h2 class="section-title fw-bold">Learn How Catholic Legacy Meets Your Needs</h2>
				<div class="row justify-content-center">
					<ng-container *ngFor="let product of products">
					<div class="col-12 col-lg-6 legacy-meet-items" *ngIf="product.selected">
						<div class="d-flex align-items-start clist-item">
							<div class="flex-shrink-0 icon">
								<img [src]="product.image" [alt]="product.title" class="flex-shrink-0" height="102" width="102">
							</div>
							<div class="d-flex flex-column w-100 content">
								<h3>{{ product.title }}</h3>
								<p>{{ product.description }}</p>
							</div>
						</div>
					</div>
				</ng-container>
				</div>
			</div>
		</section>


		<!-- ninth-section & 10th -->
		<div class="section-one">
			<ng-container *ngTemplateOutlet="catholicLegacyTemplate"></ng-container>
		</div>

	</div>
</ng-container>

<!-- Will landing page html -->
<ng-container *ngIf="landingPageType=='funeral_planning'">
	<div class="will_page_main_container">
		<section class="first-section desktop-screen" *ngIf="currentTier == 4|| currentTier == 3 || currentTier == 2"
			[ngStyle]="{ 'background-image': 'url(' + basicSectionData?.['orgBannerImage'] + ')' }">
			<div class="">
				<div class="row d-flex justify-content-end">
					<div class="infoContainer">
						<div class="universityDesc">
							<div class="logo_for_all_landing_page">
								<img [src]="basicSectionData?.['orgLogo']" class="img-fluid" height="80">
								<h2 class="fw-bold-first" style="color:white">{{basicSectionData?.['orgName']}}</h2>
							</div>
							<br>
							<div #desc class="first-section-para" [ngClass]="{ 'scroll': showFullDescription }" [class.collapsed]="!showFullDescription" [class.expanded]="showFullDescription"
							[innerHTML]="basicSectionData?.['orgParternshipDescription']">
						</div>
						
						<button *ngIf="showReadMore" (click)="toggleDescription()" class="btn btn-link p-0 read-more-btn">
							{{ showFullDescription ? 'Read Less' : 'Read More' }}
						</button>
						<br ><br>
							<button class="btn btn-primary action-btn width-act">
								{{ isSecondaryLandingPage ? 'Get Started Now' : 'Create Your Free Catholic Will Today' }}
							</button>
							<br>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- <section class="first-section mobile-screen" *ngIf="currentTier == 4 ||currentTier == 3"
			[ngStyle]="{ 'background-image': 'url(' + basicSectionData?.['orgBannerImage'] + ')' }">
			<div class="container">
				<div class="infoContainer">
					<div class="universityDesc p-4 ">
						<div class="logo_for_all_landing_page ">
							<img [src]="basicSectionData?.['orgLogo']" class="img-fluid">
						</div>
						<br>
						<h2 class="fw-bold">{{basicSectionData?.['orgName']}}</h2>
						<p>
							{{basicSectionData?.['orgParternshipDescription']}}
						</p>
						<button class="btn btn-primary action-btn">Create Your Free Catholic Will
							Today</button>
					</div>
				</div>
			</div>
		</section> -->
		<section class="first-section mobile-screen" *ngIf="currentTier == 4 ||currentTier == 3 || currentTier == 2">
            <div class="mobile-img-cntr" [ngStyle]="{ 'background-image': 'url(' + basicSectionData?.['orgBannerImage'] + ')' }">
			</div>
			<div class="container">
				<div class="infoContainer pb-5">
					<div class="universityDesc p-4">
						<div class="logo_for_all_landing_page_mobile ">
							<img [src]="basicSectionData?.['orgLogo']" style="height: 100%; border-radius: 10px;">
						</div>
						<br>
						<h2 class="fw-bold">{{basicSectionData?.['orgName']}}</h2>
						<div #descMob class="first-section-para" [ngClass]="{ 'scroll': showFullDescription }" [class.collapsed]="!showFullDescription" [class.expanded]="showFullDescription" [style.max-height.px]="showFullDescription ? 360 : null" [style.overflow-y]="showFullDescription ? 'auto' : null" [style.webkitOverflowScrolling]="showFullDescription ? 'touch' : null" [innerHTML]="basicSectionData?.['orgParternshipDescription']">
						</div>
						<button  *ngIf="showReadMoreMob" (click)="toggleDescription()" style="color: black" class="btn btn-link p-0 read-more-btn">
							{{ showFullDescription ? 'Read Less' : 'Read More' }}
						</button><br><br><br>

						<button class="btn btn-primary action-btn width-act">
							{{ isSecondaryLandingPage ? 'Get Started Now' : 'Create Your Free Catholic Will Today' }}
						</button>
					</div>
				</div>
			</div>
		</section>
		<app-will4-how-it-works-section
			(ctaClick)="$event.stopPropagation()">
		</app-will4-how-it-works-section>

		<section class="third-section" *ngIf="(currentTier == 4 || currentTier == 3 || currentTier == 2) && isactiveSupportMission">
			<div class="container">
				<div class="row align-items-center third-section-inner-container ">
					<div class="col-md-5 text-center">
						<img [src]="supportMissionSectionData?.['image_url']" alt="Mission"
							class="img-fluid custom-mission-image">
					</div>
					<div class="col-md-7 third-container-desc text-white">
						<h3 class="fw-bold-white" [innerHTML]="getSupportMissionTitle('Support Our Mission with a Gift in Your Will – Create Your Free Will Through Catholic Legacy')">
						</h3>
						<p class="mt-3 third-section-para" [innerHTML]="getSupportMissionDescription(defaultSupportMissionDescription)">
						</p>
						<button class="btn action-btn-white mt-3">
							{{ isSecondaryLandingPage ? 'Get Started Now' : 'Begin Your Estate Planning Journey' }}
						</button>
					</div>
				</div>
			</div>
		</section>

		<app-will4-legacy-help-section
			[title]="'Why Families Use Catholic Legacy’s Funeral Planning Guide'"
			[items]="funeralLegacyHelpItems">
		</app-will4-legacy-help-section>

		<section class="second-section" *ngIf="(currentTier == 3 || currentTier == 4 || currentTier == 2) && isactiveAboutUs">
			<div class="container" *ngIf="aboutUsSectionData">
				<div class="row d-flex align-items-center second-section-container">
					<div [ngClass]="{
							'col-lg-4': aboutUsSectionData?.['org_mission'],
							'col-lg-12': !aboutUsSectionData?.['org_mission']
						}">
						<div class="custom-university-container">
							<!-- <p class="text-uppercase scndSectionSubHeader"><b>About US</b></p> -->
							<h2 class="fw-bold">About Us</h2>
							<p class="fs" [innerHTML]="aboutUsSectionData?.['our_background']">
							</p>
						</div>
					</div>
					<div class="col-lg-8" *ngIf="aboutUsSectionData?.['org_mission'] && aboutUsSectionData?.['org_vision']">
						<div class="custom-info-box d-flex  text-lg-start align-items-center">
							<img src="./../../../assets/images/arrow-target.png" alt="Mission Icon" class="me-3 mvIcons">
							<div>
								<h5 class="">Mission</h5>
								<p class="fs" [innerHTML]="aboutUsSectionData?.['org_mission']"></p>
							</div>
						</div>
						<div class="custom-info-box d-flex  text-lg-start align-items-center">
							<img src="./../../../assets/images/eye-icon.png" alt="Vision Icon" class="me-3 mvIcons">
							<div>
								<h5 class="">Vision</h5>
								<p class="fs" [innerHTML]="aboutUsSectionData?.['org_vision']"></p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<app-will4-help-section
			[title]="'What You Can Include in a Catholic Funeral Plan'"
			[items]="funeralHelpItems()"
			[cta]="funeralHelpCta"
			(ctaClick)="redirectToFuneralForm()">
		</app-will4-help-section>
		<!-- Tier-3 Banner section -->
		<!-- <section class="first-section--tier3 desktop-screen" *ngIf="currentTier == 3">
			<div class="container">
				<div class="will3-logo">
					<img [src]="basicSectionData?.['orgLogo']" class="img-fluid" height="80" width="293">
				</div>
				<div class="will3-wrap row">
					<div class="will3-wrap-left col-12 col-lg-5 col-xxl-6">
						<div>
							<img [src]="basicSectionData?.['orgBannerImage']" alt="banner" title="banner" height="411"
								width="627" class="banner-image">
						</div>
					</div>
					<div class="col-12 col-lg-7 col-xxl-6 ps-xxl-0">
						<div class="will3-wrap-right">
							<br>
							<h2 class="fw-bold-first">{{basicSectionData?.['orgName']}}</h2>
							<p class="first-section-para">
								{{basicSectionData?.['orgParternshipDescription']}}
							</p>
							<button class="btn btn-primary action-btn">Create Your Free Catholic
								Will Today</button>
							<br>
						</div>
					</div>
				</div>
			</div>
		</section> -->
		<!-- Tier-2 Banner section -->
		<!-- <section class="first-section--tier2 desktop-screen" *ngIf="currentTier == 2">
			<div class="container">
				<div class="will3-wrap row for-desktop">
					<div class="will3-wrap-left col-12 col-lg-5">
						<div>
							<img [src]="basicSectionData?.['orgBannerImage']" alt="banner" title="banner" class="banner-image">
						</div>
					</div>
					<div class="col-12 col-lg-7">
						<div class="will3-wrap-right">
							<div class="logo_for_all_landing_page ">
								<img [src]="basicSectionData?.['orgLogo']" class="img-fluid" height="80">
							</div>
							<br>
							<h2 class="fw-bold-first" [title]="basicSectionData?.['orgName']">{{basicSectionData?.['orgName']}}</h2>
							<p class="first-section-para"  [innerHTML]="basicSectionData?.['orgParternshipDescription']">
							</p>
							<button class="btn btn-primary action-btn">Create Your Free Catholic
								Will Today</button>
							<br>
						</div>
					</div>
				</div>
				<div class="will3-wrap row for-mobile">
					<div class="col-12">
						<div class="will3-wrap-right">
							<div class="logo_for_all_landing_page mb-3">
								<img [src]="basicSectionData?.['orgLogo']" class="img-fluid" height="80">
							</div>
							<div>
								<img [src]="basicSectionData?.['orgBannerImage']" alt="banner" title="banner" class="banner-image">
							</div>
							<br>
							<h2 class="fw-bold-first" [title]="basicSectionData?.['orgName']">{{basicSectionData?.['orgName']}}</h2>
							<p class="first-section-para" [innerHTML]="basicSectionData?.['orgParternshipDescription']"></p>
							<button class="btn btn-primary action-btn">Create Your Free Catholic
								Will Today</button>
							<br>
						</div>
					</div>
				</div>
			</div>
		</section> -->

		<!-- ninth-section & 10th -->
		<div class="section-one">
			<ng-container *ngTemplateOutlet="catholicLegacyTemplate"></ng-container>
		</div>
	</div>
</ng-container>

<ng-container *ngIf="landingPageType=='healthcare_directive'">
	<div class="will_page_main_container">
		<section class="first-section desktop-screen" *ngIf="currentTier == 4|| currentTier == 3 || currentTier == 2"
			[ngStyle]="{ 'background-image': 'url(' + basicSectionData?.['orgBannerImage'] + ')' }">
			<div class="">
				<div class="row d-flex justify-content-end">
					<div class="infoContainer">
						<div class="universityDesc">
							<div class="logo_for_all_landing_page">
								<img [src]="basicSectionData?.['orgLogo']" class="img-fluid" height="80">
								<h2 class="fw-bold-first" style="color:white">{{basicSectionData?.['orgName']}}</h2>
							</div>
							<br>
							<div #desc class="first-section-para" [ngClass]="{ 'scroll': showFullDescription }" [class.collapsed]="!showFullDescription" [class.expanded]="showFullDescription"
							[innerHTML]="basicSectionData?.['orgParternshipDescription']">
						</div>
						
						<button *ngIf="showReadMore" (click)="toggleDescription()" class="btn btn-link p-0 read-more-btn">
							{{ showFullDescription ? 'Read Less' : 'Read More' }}
						</button>
						<br ><br>
							<button class="btn btn-primary action-btn width-act">
								{{ isSecondaryLandingPage ? 'Get Started Now' : 'Create Your Free Catholic Will Today' }}
							</button>
							<br>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- <section class="first-section mobile-screen" *ngIf="currentTier == 4 ||currentTier == 3"
			[ngStyle]="{ 'background-image': 'url(' + basicSectionData?.['orgBannerImage'] + ')' }">
			<div class="container">
				<div class="infoContainer">
					<div class="universityDesc p-4 ">
						<div class="logo_for_all_landing_page ">
							<img [src]="basicSectionData?.['orgLogo']" class="img-fluid">
						</div>
						<br>
						<h2 class="fw-bold">{{basicSectionData?.['orgName']}}</h2>
						<p>
							{{basicSectionData?.['orgParternshipDescription']}}
						</p>
						<button class="btn btn-primary action-btn">Create Your Free Catholic Will
							Today</button>
					</div>
				</div>
			</div>
		</section> -->
		<section class="first-section mobile-screen" *ngIf="currentTier == 4 ||currentTier == 3 || currentTier == 2">
            <div class="mobile-img-cntr" [ngStyle]="{ 'background-image': 'url(' + basicSectionData?.['orgBannerImage'] + ')' }">
			</div>
			<div class="container">
				<div class="infoContainer pb-5">
					<div class="universityDesc p-4">
						<div class="logo_for_all_landing_page_mobile ">
							<img [src]="basicSectionData?.['orgLogo']" style="height: 100%; border-radius: 10px;">
						</div>
						<br>
						<h2 class="fw-bold">{{basicSectionData?.['orgName']}}</h2>
						<div #descMob class="first-section-para" [ngClass]="{ 'scroll': showFullDescription }" [class.collapsed]="!showFullDescription" [class.expanded]="showFullDescription" [style.max-height.px]="showFullDescription ? 360 : null" [style.overflow-y]="showFullDescription ? 'auto' : null" [style.webkitOverflowScrolling]="showFullDescription ? 'touch' : null" [innerHTML]="basicSectionData?.['orgParternshipDescription']">
						</div>
						<button  *ngIf="showReadMoreMob" (click)="toggleDescription()" style="color: black" class="btn btn-link p-0 read-more-btn">
							{{ showFullDescription ? 'Read Less' : 'Read More' }}
						</button><br><br><br>

						<button class="btn btn-primary action-btn width-act">
							{{ isSecondaryLandingPage ? 'Get Started Now' : 'Create Your Free Catholic Will Today' }}
						</button>
					</div>
				</div>
			</div>
		</section>
		<!-- Tier-3 Banner section -->
		<!-- <section class="first-section--tier3 desktop-screen" *ngIf="currentTier == 3">
			<div class="container">
				<div class="will3-logo">
					<img [src]="basicSectionData?.['orgLogo']" class="img-fluid" height="80" width="293">
				</div>
				<div class="will3-wrap row">
					<div class="will3-wrap-left col-12 col-lg-5 col-xxl-6">
						<div>
							<img [src]="basicSectionData?.['orgBannerImage']" alt="banner" title="banner" height="411"
								width="627" class="banner-image">
						</div>
					</div>
					<div class="col-12 col-lg-7 col-xxl-6 ps-xxl-0">
						<div class="will3-wrap-right">
							<br>
							<h2 class="fw-bold-first">{{basicSectionData?.['orgName']}}</h2>
							<p class="first-section-para">
								{{basicSectionData?.['orgParternshipDescription']}}
							</p>
							<button class="btn btn-primary action-btn">Create Your Free Catholic
								Will Today</button>
							<br>
						</div>
					</div>
				</div>
			</div>
		</section> -->
		<!-- Tier-2 Banner section -->
		<!-- <section class="first-section--tier2 desktop-screen" *ngIf="currentTier == 2">
			<div class="container">
				<div class="will3-wrap row for-desktop">
					<div class="will3-wrap-left col-12 col-lg-5">
						<div>
							<img [src]="basicSectionData?.['orgBannerImage']" alt="banner" title="banner" class="banner-image">
						</div>
					</div>
					<div class="col-12 col-lg-7">
						<div class="will3-wrap-right">
							<div class="logo_for_all_landing_page ">
								<img [src]="basicSectionData?.['orgLogo']" class="img-fluid" height="80">
							</div>
							<br>
							<h2 class="fw-bold-first" [title]="basicSectionData?.['orgName']">{{basicSectionData?.['orgName']}}</h2>
							<p class="first-section-para"  [innerHTML]="basicSectionData?.['orgParternshipDescription']">
							</p>
							<button class="btn btn-primary action-btn">Create Your Free Catholic
								Will Today</button>
							<br>
						</div>
					</div>
				</div>
				<div class="will3-wrap row for-mobile">
					<div class="col-12">
						<div class="will3-wrap-right">
							<div class="logo_for_all_landing_page mb-3">
								<img [src]="basicSectionData?.['orgLogo']" class="img-fluid" height="80">
							</div>
							<div>
								<img [src]="basicSectionData?.['orgBannerImage']" alt="banner" title="banner" class="banner-image">
							</div>
							<br>
							<h2 class="fw-bold-first" [title]="basicSectionData?.['orgName']">{{basicSectionData?.['orgName']}}</h2>
							<p class="first-section-para" [innerHTML]="basicSectionData?.['orgParternshipDescription']"></p>
							<button class="btn btn-primary action-btn">Create Your Free Catholic
								Will Today</button>
							<br>
						</div>
					</div>
				</div>
			</div>
		</section> -->
		<app-will4-healthcare-how-it-works-section
			(ctaClick)="redirectToHealthcareDirectiveForm()">
		</app-will4-healthcare-how-it-works-section>

		<section class="third-section" *ngIf="(currentTier == 4 || currentTier == 3 || currentTier == 2) && isactiveSupportMission">
			<div class="container">
				<div class="row align-items-center third-section-inner-container ">
					<div class="col-md-5 text-center">
						<img [src]="supportMissionSectionData?.['image_url']" alt="Mission"
							class="img-fluid custom-mission-image">
					</div>
					<div class="col-md-7 third-container-desc text-white">
						<h3 class="fw-bold-white" [innerHTML]="getSupportMissionTitle('Support Our Mission with a Gift in Your Will – Create Your Free Will Through Catholic Legacy')">
						</h3>
						<p class="mt-3 third-section-para" [innerHTML]="getSupportMissionDescription(defaultSupportMissionDescription)">
						</p>
						<button class="btn action-btn-white mt-3">
							{{ isSecondaryLandingPage ? 'Get Started Now' : 'Begin Your Estate Planning Journey' }}
						</button>
					</div>
				</div>
			</div>
		</section>

		<div class="legacy-section wait-section">
			<div class="container container-mobile">
				<h2>Why Use Catholic Legacy’s Healthcare Directive</h2>

				<div class="will-legacy-content">
					<div class="will-legacy-block">
						<div class="will-legacy-image">
							<img src="../../../assets/images/future8.webp" alt="Hospitals Make Decisions Quickly">
						</div>
						<div class="will-legacy-text">
							<h3>Be Prepared for Medical Emergencies</h3>
							<p>Medical decisions often need to be made quickly. A Directive allows you to appoint a trusted person to make health care decisions if you are unable to speak for yourself.</p>
						</div>
					</div>

					<div class="will-legacy-block">
						<div class="will-legacy-image">
							<img src="../../../assets/images/health10.webp"
								alt="Medical Decisions Can Be Stressful for Families">
						</div>
						<div class="will-legacy-text">
							<h3>Ensure Your Faith Is Respected</h3>
							<p>Catholic Legacy's Directive reflects Catholic teaching on the dignity of life, compassionate care, and ethical medical decision-making. The document was developed in consultation with the National Catholic Bioethics Center (NCBC).</p>
						</div>
					</div>

					<div class="will-legacy-block">
						<div class="will-legacy-image">
							<img src="../../../assets/images/college-landing01.webp" alt="Protect Your Rights and Your Faith">
						</div>
						<div class="will-legacy-text">
							<h3>Important for College Students and Young Adults</h3>
							<p>Once a person turns 18, parents may no longer automatically have access to medical information or decision-making authority. A Directive helps families prepare for unexpected situations.</p>
						</div>
					</div>
				</div>

				<!-- <div class="will-legacy-content mt-20">
					<div class="will-legacy-block">
						<div class="will-legacy-image">
							<img src="../../../assets/images/health9.webp" alt="Peace of Mind">
						</div>
						<div class="will-legacy-text">
							<h3>Reduce Stress for Families During Difficult Times</h3>
							<p>Unexpected medical situations can create confusion and emotional stress for loved ones. Having health care wishes documented in advance can help families better understand important decisions and responsibilities during critical moments.</p>
						</div>
					</div>

					<div class="will-legacy-block">
						<div class="will-legacy-image">
							<img src="../../../assets/images/future7.webp" alt="Empowerment">
						</div>
						<div class="will-legacy-text">
							<h3>Free, Secure, and Accessible Anytime</h3>
							<p>Catholic Legacy’s Healthcare Directive is completely free, accessible online, and easy to complete. Documents can be reviewed and updated anytime as health care needs or circumstances change.</p>
						</div>
					</div>

					<div class="will-legacy-block"></div>
				</div> -->
			</div>
		</div>

		<section class="second-section" *ngIf="(currentTier == 3 || currentTier == 4 || currentTier == 2) && isactiveAboutUs">
			<div class="container" *ngIf="aboutUsSectionData">
				<div class="row d-flex align-items-center second-section-container">
					<div [ngClass]="{
							'col-lg-4': aboutUsSectionData?.['org_mission'],
							'col-lg-12': !aboutUsSectionData?.['org_mission']
						}">
						<div class="custom-university-container">
							<!-- <p class="text-uppercase scndSectionSubHeader"><b>About US</b></p> -->
							<h2 class="fw-bold">About Us</h2>
							<p class="fs" [innerHTML]="aboutUsSectionData?.['our_background']">
							</p>
						</div>
					</div>
					<div class="col-lg-8" *ngIf="aboutUsSectionData?.['org_mission'] && aboutUsSectionData?.['org_vision']">
						<div class="custom-info-box d-flex  text-lg-start align-items-center">
							<img src="./../../../assets/images/arrow-target.png" alt="Mission Icon" class="me-3 mvIcons">
							<div>
								<h5 class="">Mission</h5>
								<p class="fs" [innerHTML]="aboutUsSectionData?.['org_mission']"></p>
							</div>
						</div>
						<div class="custom-info-box d-flex  text-lg-start align-items-center">
							<img src="./../../../assets/images/eye-icon.png" alt="Vision Icon" class="me-3 mvIcons">
							<div>
								<h5 class="">Vision</h5>
								<p class="fs" [innerHTML]="aboutUsSectionData?.['org_vision']"></p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<app-will4-legacy-help-section
			[title]="'How Catholic Legacy Helps'"
			[items]="healthcareDirectiveLegacyHelpItems"
			[cta]="healthcareDirectiveHelpCta"
			(ctaClick)="redirectToHealthcareDirectiveForm()">
		</app-will4-legacy-help-section>
		
		<!-- ninth-section & 10th -->
		<div class="section-one">
			<ng-container *ngTemplateOutlet="catholicLegacyTemplate"></ng-container>
		</div>
	</div>
</ng-container>

<!-- For more flexible reuse, define a template with parameters -->
<ng-template #catholicLegacyTemplate let-title="title" let-showForm="showForm" let-faqsToShow="faqsToShow">
	<section *ngIf="!isLogin" class="ninth-section">
		<div class="container">
			<div class="section-container">
				<div class="">
					<div class="row row-container" [ngStyle]="{'flex-direction': isReversed ? 'row-reverse' : 'row'}">
						<!-- Left Side: Content + Image -->
						<div class="col-lg-6 text-white">
							<h2 class="fw-bold-white">Secure Your Legacy with Purpose and Faith.</h2>
							<p class="mt-3">
								Your estate is more than assets—it’s a reflection of your faith, your values, and
								the people
								and causes you hold dear. With Catholic Legacy, you can create a free, legally sound
								Will
								that ensures your loved ones are cared for and your faith continues to make an
								impact for
								generations to come. Consider leaving a gift to your parish, Catholic charity, or
								school,
								allowing your legacy to serve others in a meaningful way.
							</p>
							<div class="image-container mt-4">
								<img [src]="signUpFormSectionData?.['image_url'] || './../../../assets/images/oldgrandparents.webp'"
									class="img-fluid width-100 rounded-image" alt="Happy Family">
							</div>
							<p class="italic-text mt-3 text-center">{{ isSecondaryLandingPage ? 'Your faith. Your legacy. Get started today!!' : 'Your faith. Your legacy. Start your Will today!!' }}
							</p>
						</div>

						<!-- Right Side: Signup Form -->
						<div class="col-lg-5">
							<div class="form-container">
								<!-- <form>
			                  <div class="row">
			                    <div class="col-md-6">
			                      <label class="form-label">First name *</label>
			                      <input type="text" class="form-control" placeholder="First Name">
			                    </div>
			                    <div class="col-md-6">
			                      <label class="form-label marginTop15">Last name *</label>
			                      <input type="text" class="form-control" placeholder="Last Name">
			                    </div>
			                  </div>

			                  <div class="mt-3">
			                    <label class="form-label">Email Address *</label>
			                    <input type="email" class="form-control" placeholder="Email Address">
			                  </div>

			                  <div class="mt-3 pwd-wrap">
			                    <label class="form-label">Password *</label>
			                    <input [type]="passwordVisible ? 'text' : 'password'" class="form-control" placeholder="Password">
			                    <span class="password-type" (click)="passwordVisible = !passwordVisible">
			                        <img *ngIf="passwordVisible" src="./assets/images/Show.svg">
			                        <img *ngIf="!passwordVisible" src="./assets/images/hidden.svg">
			                    </span>
			                  </div>

			                  <div class="mt-3 pwd-wrap">
			                    <label class="form-label">Confirm Password *</label>
			                    <input [type]="confirmPasswordVisible ? 'text' : 'password'" class="form-control" placeholder="Confirm Password">
			                    <span class="password-type"
			                            (click)="confirmPasswordVisible = !confirmPasswordVisible">
			                            <img *ngIf="confirmPasswordVisible" src="./assets/images/Show.svg">
			                            <img *ngIf="!confirmPasswordVisible" src="./assets/images/hidden.svg">
			                    </span>
			                  </div>

			                  <div class="form-check mt-3 align-item-center">
			                    <input type="checkbox" class="form-check-input">
			                    <label class="form-check-label">
			                        I agree to the <a href="/terms-of-use" target="_blank" class="terms">Terms of Use</a> & <a href="/privacy-policy" target="_blank" class="terms">Privacy Policy</a>
			                    </label>
			                  </div>

			                  <div class="d-flex justify-content-between mt-4 login-btn-container">
			                    <button type="submit" class="btn action-btn btn-lg">SIGN UP</button>
			                    <button type="button" class="btn action-btn-white btn-white-outline btn-lg">LOG IN</button>
			                  </div>
			                </form> -->
								<form [formGroup]="createAccountForm">
									<div class="row">
										<div class="col-lg-6 col-md-12">
											<div class="form-group mb-4">
												<label>First Name *</label>
												<input id="fName" type="text" formControlName="firstName" (click)="$event.stopPropagation()"
													[ngClass]="{ 'is-invalid': submitted && f.firstName.errors }"
													required="" class="form-control" readonly>
												<!-- <div *ngIf="f.firstName.invalid && (f.firstName.dirty || f.firstName.touched)"
													class="invalid-feedback">
													<div *ngIf="f.firstName.errors.required">First Name is required.
													</div>
													<div *ngIf="f.firstName.errors.invalidName">Enter valid first
														name.
													</div>
												</div> -->
											</div>
										</div>
										<div class="col-lg-6 col-md-12">
											<div class="form-group mb-4">
												<label>Last Name *</label>
												<input id="lName" type="text" formControlName="lastName" (click)="$event.stopPropagation()"
													[ngClass]="{ 'is-invalid': submitted && f.lastName.errors }"
													required="" class="form-control" readonly>
												<!-- <div *ngIf="f.lastName.invalid && (f.lastName.dirty || f.lastName.touched)"
													class="invalid-feedback">
													<div *ngIf="f.lastName.errors.required">Last Name is required.
													</div>
													<div *ngIf="f.lastName.errors.invalidName">Enter valid last
														name.</div>
												</div> -->
											</div>
										</div>
									</div>
									<div class="form-group mb-4">
										<label>Email Address *</label>
										<input id="inputEmail" type="email" formControlName="email" (click)="$event.stopPropagation()"
											[ngClass]="{ 'is-invalid': submitted && f.email.errors }" required=""
											class="form-control" readonly>
										<!-- <div *ngIf="f.email.invalid && (f.email.dirty || f.email.touched)"
											class="invalid-feedback">
											<div *ngIf="f.email.errors.required">Email is required.</div>
											<div *ngIf="f.email.errors.invalidEmail">Please enter valid Email.
											</div>
										</div> -->
									</div>
									<div class="form-group mb-4 pwd-wrap">
										<label>Password *</label>
										<div class="password-container">
											<input id="inputPassword" [type]="passwordVisible ? 'text' : 'password'" (click)="$event.stopPropagation()"
												formControlName="password"
												[ngClass]="{ 'is-invalid': submitted && f.password.errors }" required=""
												class="form-control" (input)="validatePassword(f.password.value)" readonly>
											<span class="password-type" (click)="passwordVisible = !passwordVisible">
												<img *ngIf="passwordVisible" src="./assets/images/Show.svg">
												<img *ngIf="!passwordVisible" src="./assets/images/hidden.svg">
											</span>
										</div>
										<!-- <div *ngIf="f.password.invalid && (f.password.dirty || f.password.touched)"
											class="invalid-feedback">
											<div *ngIf="f.password.errors.required">Password is required.</div>
										</div>
										<ng-container *ngIf="f.password?.errors?.invalidPassword">
											<div class="password-requirment">Password must meet the following
												requirements:
												<ul *ngIf="(f.password.dirty || f.password.touched)"
													class="password-criteria">
													<li
														[ngClass]="{'text-success': validatePassword(f.password.value).minLength, 'text-danger': !validatePassword(f.password.value).minLength}">
														Must contain minimum 8 characters
													</li>
													<li
														[ngClass]="{'text-success': validatePassword(f.password.value).maxLength, 'text-danger': !validatePassword(f.password.value).maxLength}">
														Must contain maximum 30 characters
													</li>
													<li
														[ngClass]="{'text-success': validatePassword(f.password.value).upperCase, 'text-danger': !validatePassword(f.password.value).upperCase}">
														Should contain at least one upper case letter
													</li>
													<li
														[ngClass]="{'text-success': validatePassword(f.password.value).lowerCase, 'text-danger': !validatePassword(f.password.value).lowerCase}">
														Should contain at least one lower case letter
													</li>
													<li
														[ngClass]="{'text-success': validatePassword(f.password.value).numeric, 'text-danger': !validatePassword(f.password.value).numeric}">
														Should contain at least one numeric character
													</li>
													<li
														[ngClass]="{'text-success': validatePassword(f.password.value).specialChar, 'text-danger': !validatePassword(f.password.value).specialChar}">
														Should contain at least one special character from the
														following:
														<br> {{specialCharacters}}
													</li>
												</ul>
											</div>
										</ng-container> -->
									</div>
									<div class="form-group mb-4 pwd-wrap">
										<label>Confirm Password *</label>
										<div class="password-container">
											<input id="confirmPassword" (click)="$event.stopPropagation()"
												[type]="confirmPasswordVisible ? 'text' : 'password'"
												formControlName="confirmPwd"
												[ngClass]="{ 'is-invalid': submitted && f.confirmPwd.errors }"
												required="" class="form-control" readonly>
											<span class="password-type"
												(click)="confirmPasswordVisible = !confirmPasswordVisible">
												<img *ngIf="confirmPasswordVisible" src="./assets/images/Show.svg">
												<img *ngIf="!confirmPasswordVisible" src="./assets/images/hidden.svg">
											</span>
										</div>
										<!-- <div *ngIf="f.confirmPwd.invalid && (f.confirmPwd.dirty || f.confirmPwd.touched)"
											class="invalid-feedback">
											<div *ngIf="f.confirmPwd.errors.required">Confirm Password is required.
											</div>
											<div *ngIf="f.confirmPwd.errors.confirmPwd">Password and Confirm
												Password fields
												must match.</div>
										</div> -->
									</div>
									<div class="">
										<div class="top-section">
											<input type="checkbox" class="form-check-input" formControlName="agreement" (click)="$event.preventDefault()">
											<p>I agree to the <span class="hyperLink">Terms of Use</span> & <span
													class="hyperLink">Privacy Policy</span></p>
										</div>
										<!-- <div *ngIf="f.agreement.invalid && (f.agreement.dirty || f.agreement.touched)"
											class="invalid-feedback">
											<div *ngIf="f.agreement.errors.required">Please agree to our Terms of
												Use &
												Privacy Policy to complete registration.</div>
										</div>
										<div *ngIf="f.agreement.valid && (f.agreement.dirty || f.agreement.touched)"
											class="invalid-feedback">
											<div *ngIf="f.agreement.value === false" class="test">Please agree to
												our Terms
												of Use & Privacy Policy to complete registration.</div>
										</div> -->
									</div>
									<div class="d-flex justify-content-between mt-4 login-btn-container">
										<button type="submit" class="btn action-btn btn-lg">SIGN UP</button>
										<!-- <button type="button" class="btn action-btn-white btn-white-outline btn-lg" routerLink="/login">LOG IN</button> -->
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<div class="parallex2">
		<section class="last-section">
			<div class="conatiner">
				<div class="faqs">
					<div class="container container-mobile">
						<h2 class="fw-bold">FAQs</h2>
						<div class="accordion" id="accordionExample">
							<div class="accordion-item" *ngFor="let data of (pageTemplate() === 'funeral_planning' ? funeralPlanningFaqData : pageTemplate() === 'healthcare_directive' ? healthcareDirectiveFaqData : faqData); index as i">
								<h2 class="accordion-header" id="{{data._id}}">
									<button class="accordion-button" type="button" [class.collapsed]="data.isCollapsed"
										(click)="toggleAccordion(data)">
										<span>{{data.question}}</span>
									</button>
								</h2>
								<div [attr.id]="'collapse' + data._id + i" class="accordion-collapse collapse"
									[class.show]="!data.isCollapsed" [attr.aria-labelledby]="data._id"
									data-bs-parent="#accordionExample">
									<div class="accordion-body">
										<!-- Use *ngIf to check if data.answer exists before rendering -->
										<p *ngIf="data.answer" [innerHTML]="data.answer"></p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- <div class="testimonial">
					<div class="resources-wrap2 article-wrap" *ngIf="!noTestimonial">
						<div class="container container-mobile" style="width: 90% !important;">
							

							<owl-carousel-o *ngIf="testimonailData && testimonailData.length > 0"
								[options]="customOptions2" id="resourcesSlider2">
								<ng-container *ngFor="let data of testimonailData">
									<ng-template carouselSlide [id]="data._id">
										<div class="sliderContainer"
											[ngClass]="{'oneTestimony': testimonailData.length === 1}">
											<div class="video-wrap-testimonial">
												<img [src]="data.thumbnail" alt="Resources">
											</div>
											<div class="description-cotainer">

												<blockquote style="height: fit-content;">
													{{ (data.clientTestimony.length > 200) ? (data.clientTestimony |
													slice:0:200) +
													'...' : data.clientTestimony }}

												</blockquote>
												<div class="client-info">
													<div class="client-name">
														{{ (data.clientName.length > 20) ? (data.clientName |
														slice:0:20) + '...' :
														data.clientName }}
													</div>
												</div>

											</div>

										</div>
									</ng-template>
								</ng-container>
							</owl-carousel-o>
						</div>
					</div>
				</div> -->

				<!-- //new testimonials -->
				<section class="tcarousel-1-section">
					<h2 class="mt-5">Testimonials</h2>
					<p class="headerText">What Users Are Saying
						<!-- Hear what our users have to say about Catholic Legacy and
						<a class="link" style="cursor: pointer;">contact us</a> with
						your
						feedback. -->
					</p>
					<div class="tcarousel-1-wrapper" [class.two-items]="carouselItems?.length === 2">
				
						<div class="tcarousel-1-item" id="resourcesSlider3" *ngFor="let data of carouselItems; let i = index" [ngClass]="getCardClass(i)">
				
							<div class="tcarousel-1-card">
				
								<div class="tcarousel-1-image-wrapper">
									<img [src]="data.thumbnail" alt="Resources"/>
								</div>
				
								<div class="tcarousel-1-content">
									<div class="tcarousel-1-stars">
										<ng-container *ngIf="data.rating && data.rating > 0">
										<span *ngFor="let s of stars">
											{{ s <= data.rating ? '★' : '☆' }} </span>
										</ng-container>
									</div>
									<div class="tcarousel-1-text"><blockquote style="height: fit-content;">{{ (data.clientTestimony?.length > 200) ? (data.clientTestimony |
													slice:0:200) +
													'...' : data.clientTestimony }} </blockquote></div>
									<p class="tcarousel-1-name" [title]="data.clientName">- {{ (data.clientName?.length > 20) ? (data.clientName |
														slice:0:20) + '...' :
														data.clientName }}</p>
								</div>
				
							</div>
				
						</div>
				
					</div>
				</section>
				</div>
		</section>
	</div>

</ng-template>

<div class="footer-wrapper">
	<div class="footer-blocker"></div>
	<app-footer></app-footer>
</div>